import { Logo } from '../components/Logo';
import { scrollToId } from '../lib/smoothScroll';

const navLinks = [
  { label: 'Platform', id: 'platform' },
  { label: "Who It's For", id: 'who-its-for' },
  { label: 'Our Approach', id: 'approach' },
  { label: 'Integrations', id: 'integrations' },
  { label: 'Contact', id: 'enquiry' },
];

export const Footer = () => (
  <footer className="border-t border-[#E5E7EB] bg-[#FAFAF7] py-14" data-testid="footer">
    <div className="container-relay">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-xs">
          <Logo />
          <p className="mt-4 text-sm leading-relaxed text-[#6B7280]">
            Operational software for connected fleet service.
          </p>
        </div>
        <nav className="grid grid-cols-2 gap-x-16 gap-y-3 sm:grid-cols-1" aria-label="Footer">
          {navLinks.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-left text-sm font-medium text-[#374151] transition-colors duration-150 hover:text-[#0F5C4A]"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div>
          <p className="font-op mb-3 text-[10px] font-medium uppercase tracking-[0.22em] text-[#6B7280]">Get in touch</p>
          <a
            href="mailto:hello@relaybyavenir.com"
            data-testid="footer-email"
            className="text-sm font-semibold text-[#0F5C4A] underline-offset-4 hover:underline"
          >
            hello@relaybyavenir.com
          </a>
        </div>
      </div>
      <div className="mt-12 flex flex-col gap-3 border-t border-[#E5E7EB] pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-[#9CA3AF]">© 2026 AVENIR Relay. All rights reserved.</p>
        <div className="flex gap-6">
          <button
            data-testid="footer-cookie-preferences"
            onClick={() => window.dispatchEvent(new Event('relay:open-cookie-preferences'))}
            className="text-xs font-medium text-[#6B7280] underline-offset-4 hover:text-[#0F5C4A] hover:underline"
          >
            Cookie preferences
          </button>
          <a href="/privacy" data-testid="footer-privacy" className="text-xs font-medium text-[#6B7280] underline-offset-4 hover:text-[#0F5C4A] hover:underline">
            Privacy
          </a>
          <a href="/terms" data-testid="footer-terms" className="text-xs font-medium text-[#6B7280] underline-offset-4 hover:text-[#0F5C4A] hover:underline">
            Terms
          </a>
        </div>
      </div>
    </div>
  </footer>
);
